import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import ServiceBrandLogo from '../../../../components/ServiceBrandLogo/ServiceBrandLogo';

const ServicesBrandLogos = () => {
   return (
      <>
         {/* <div className="brand-area theme-dark-bg pt-100 pb-100"> */}
         <div className="brand-area pt-2 pb-2" style={{border: " 3px #00000045 double", marginLeft: "5px", marginRight: "5px"}}>
            <div className="container">
               <div className="brand-active-two swiper-container">

                  <Swiper
                     spaceBetween={30}
                     slidesPerView={1}
                     className='swiper-wrapper'
                     autoplay={{ delay: 3000 }}
                     breakpoints={{
                        550: {
                           slidesPerView: 1,
                        },
                        768: {
                           slidesPerView: 3,
                        },
                        1200: {
                           slidesPerView: 4,
                        },                        
                     }}
                     navigation={{ nextEl: '.brand-button-next', prevEl: '.brand-button-prev', }}
                     // onSlideChange={() => console.log('slide change')}
                     // onSwiper={(swiper) => console.log(swiper)}
                  >
                     <SwiperSlide>
                        <ServiceBrandLogo logo_num="10" linkk="https://bwdisrupt.businessworld.in/article/We-Aim-To-Touch-70K-MSMEs-Through-Loan-Digibizz-Offerings-By-April-2022-Arun-Nayyar-CEO-NeoGrowth-Credit/13-01-2022-417570/"></ServiceBrandLogo>
                     </SwiperSlide>

                     <SwiperSlide>
                        <ServiceBrandLogo logo_num="11" linkk="https://www.livemint.com/companies/start-ups/covid-hastens-smb-shift-to-digital-sales-11646594624709.html"></ServiceBrandLogo>
                     </SwiperSlide>

                     <SwiperSlide>
                        <ServiceBrandLogo logo_num="12" linkk="https://www.peoplematters.in/site/interstitial?return_to=%2Farticle%2Fstrategic-hr%2Fhow-to-attract-and-engage-gen-z-employees-in-2022-32404"></ServiceBrandLogo>
                     </SwiperSlide>

                     <SwiperSlide>
                        <ServiceBrandLogo logo_num="13" linkk="https://cio.economictimes.indiatimes.com/news/business-analytics/why-is-analytics-important-in-fintech-lending/90266969"></ServiceBrandLogo>
                     </SwiperSlide>

                     <SwiperSlide>
                        <ServiceBrandLogo logo_num="14" linkk="https://yourstory.com/smbstory/india-covid-19-omicron-third-wave-msmes/amp"></ServiceBrandLogo>
                     </SwiperSlide>                     

                  </Swiper>

               </div>
            </div>
         </div>
      </>
   );
};

export default ServicesBrandLogos;